import getIn from 'transmute/getIn';
import { TICKET_DATA } from '../constants/KeyPaths';
const getTicketData = getIn(TICKET_DATA);
export default getTicketData;